import { all } from 'redux-saga/effects';

//public
// import AccountSaga from './auth/register/saga';
import AuthSaga from './auth/login/saga';
import ForgetSaga from './auth/forgetpwd/saga';
import LayoutSaga from './layout/saga';
import ResetPwd from './auth/resetPwd/saga';
import RegisterSaga from "./auth/register/saga";

/////////
import Campaign from './contents/campaign/saga';
import ScreenSaga from "./contents/screen/saga";
import SvaedCampaignsSaga from "./contents/saved_campaign/saga";
import AdminSaga from "./contents/admin/saga";
import ReportSaga from "./contents/report/saga";


export default function* rootSaga() {
    yield all([
        AuthSaga(),
        ForgetSaga(),
        LayoutSaga(),
        ResetPwd(),
        RegisterSaga(),

        Campaign(),
        ScreenSaga(),
        SvaedCampaignsSaga(),
        AdminSaga(),
        ReportSaga()
    ])
}